import React, { useState } from 'react';
import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import emailjs from 'emailjs-com'; // ✅ EmailJS added
import './Footer.scss';
import WhatsAppButton from '../../components/Whatsapp/WhatsAppButton';

const Footer = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name || !email || !message) {
      setError('Please fill out all fields.');
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);

    try {
      await emailjs.send(
        'service_uy0k8d9',      // ✅ Your Service ID
        'template_n2lnl48',     // ✅ Your Template ID
        {
          name: name,
          email: email,
          message: message,
        },
        '_sqAqIItK2lWjiPoW'      // ✅ Your Public Key
      );

      setIsFormSubmitted(true);
      setFormData({ name: '', email: '', message: '' });
    } catch (err) {
        console.log("EMAILJS ERROR:", err);

        if (err.text) {
          setError(err.text);
        } else {
          setError("Something went wrong.");
        }
      } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h2 className="head-text">Take a coffee & chat with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:info@gomaldesignstudio.com" className="p-text">
            info@gomaldesignstudio.com
          </a>
        </div>

        <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+33605905713" className="p-text">
            +33 605 905 713
          </a>
        </div>
      </div>

      {!isFormSubmitted ? (
        <form className="app__footer-form app__flex" onSubmit={handleSubmit}>
          <div className="app__flex">
            <input
              className="p-text"
              type="text"
              placeholder="Your Name"
              name="name"
              value={name}
              onChange={handleChangeInput}
            />
          </div>

          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
            />
          </div>

          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              name="message"
              value={message}
              onChange={handleChangeInput}
            />
          </div>

          <button type="submit" className="p-text" disabled={loading}>
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      ) : (
        <h3 className="head-text">Thank you for getting in touch!</h3>
      )}

      {error && <p className="error-message">{error}</p>}
      <WhatsAppButton/>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
  true,
  false,
  true
);
